import { getMessage } from "../../../utils/getMessage";
import { userContext } from "../../views/html/FormComponent";
import { useContext } from "react";

export const CharCounter = ({ contadorTexto, maxFromProp }) => {
  const { maxChars } = useContext(userContext);

  const fallbackMax = 100;
    const maxLength = maxFromProp ?? maxChars ?? fallbackMax;
  return (
    <div className="charcounter">
      {contadorTexto} {getMessage(21) || "caracteres escritos"} ({maxLength}{" "}
      {getMessage(10) || "máximo"})
    </div>
  );
};
